import { render, staticRenderFns } from "./PricelistItem.vue?vue&type=template&id=113be586&"
import script from "./PricelistItem.vue?vue&type=script&lang=js&"
export * from "./PricelistItem.vue?vue&type=script&lang=js&"
import style0 from "./PricelistItem.vue?vue&type=style&index=0&id=113be586&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports